import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import { useIntl } from 'umi';
import Button from '@material-ui/core/Button';
import DateRangePickerML from '@/components/DateRangePickerML';
import ClearIconML from '@/components/ClearIconML/index';
import SearchGroupStyled from './SearchGroupStyled';
import webStorage from '@/utils/storageManager';

const SearchGroup = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const { ACTIVITY_COUPON_STATUS } = webStorage.get('DICTOBJ') || {};
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { name, status, beginDateTime, endDateTime } = query;
  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      name,
      status,
    },
  });

  //置空输入框
  const handleClearStatus = () => {
    setValue('status', '');
  };
  const watchStatus = watch('status');
  const [campaignName, setCampaignName] = useState();
  //活动时间的重置
  const [isReset, setIsReset] = useState();
  useEffect(() => {
    if (name) {
      setCampaignName(name);
    }
  }, [name]);
  //查询
  const handleSearchClick = (values) => {
    const { date, ...restParam } = values;
    const searchParam = {
      ...restParam,
      beginDateTime: date?.startDate,
      endDateTime: date?.endDate,
    };
    handleSearch(searchParam);
  };
  //重置
  const handleResetClick = () => {
    setCampaignName();
    const resetSearch = {
      name: '',
      status: '',
    };
    reset(resetSearch);
    setIsReset(true);
    restClick && restClick(resetSearch);
  };
  return (
    <SearchGroupStyled>
      <form onSubmit={handleSubmit(handleSearchClick)}>
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="first-line">
              <Controller
                render={(rp) => (
                  <TextField
                    variant="standard"
                    name="name"
                    autoComplete="false"
                    control={control}
                    onChange={(e) => {
                      setValue('name', e.target.value);
                      setCampaignName(e.target.value);
                      return rp.value;
                    }}
                    value={rp.value ?? campaignName}
                    id="basic"
                    className="campaignName"
                    label="活动名称"
                    defaultValue=""
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setCampaignName();
                              setValue('name', '');
                            }}
                            edge="end"
                          >
                            {campaignName && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="name"
                control={control}
                id="basic"
                className="input"
              />
              <FormControl variant="standard" className="date">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="核销时间"
                      startText="开始日期"
                      endText="结束日期"
                      defaultStartDate={beginDateTime}
                      defaultEndDate={endDateTime}
                      rp={rp}
                      setValue={setValue}
                      onChange={() => setIsReset(false)}
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>
              <FormControl variant="standard" className="channel single-select">
                <InputLabel>状态</InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {ACTIVITY_COUPON_STATUS?.map((item) => (
                        <MenuItem key={item.dictCode} value={item.dictCode}>
                          {item.nameZh}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  name="status"
                  variant="standard"
                  defaultValue=""
                  control={control}
                  className="status"
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleResetClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_marketing_activity_voucher_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
